import React from 'react';
import Body from '../../components/Body';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import styles from './Desktop.module.css';

export default function Desktop(props) {
  const {
    popup,
    closePopup,
  } = props;

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  const getPopupStyle = () => {
    let popupStyle = { width: "31.25vw" };
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "50%" };
    }
    return popupStyle;
  };

  return (
    <div className={styles.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <Body {...props} />
    </div>
  );
}
